/****************************************************************************
 * COPYRIGHT (c) 2024 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
import {
  FETCH_USER_DATA_REQUEST,
  FETCH_USER_DATA_SUCCESS,
  FETCH_USER_DATA_FAILURE,
} from "./UserDataTypes";
  
  const initialState = {
    loading: false,
    ids: [],
    error: "",
    userData:{
      results: [],
    }
  };
  
  const userDataReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_USER_DATA_REQUEST:
        return {
          ...state,
          loading: true,
        };
  
      case FETCH_USER_DATA_SUCCESS:
        return {
          loading: false,
          userData: action.payload,
          error: "",
        };
      case FETCH_USER_DATA_FAILURE:
        return {
          loading: false,
          userData: {},
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default userDataReducer;
  